"use client"
import { ConfigProvider, Spin } from 'antd';
import { registerLicense } from '@syncfusion/ej2-base';

import React, { useEffect, useState } from 'react';
import container from '@/lib/di/container';
import { TollAreaRepo, TollAreaStatistics } from '@/core/repos/tables/toll-area.repo';
import { FilterInputTemplate, FilterInputType, FilterBar } from './components/filter/FilterBar';
import { FilterSearchPayload } from './components/table/DataTable';
import { TollAreaStatisticsTable } from './dashboard/components/TollAreaStatsTable';
import { HelpModal } from './dashboard/modals/HelpModal';
import { GlobalUtils } from './utils/global.utils';

const tollAreaRepo = container.get(TollAreaRepo);

export default function DashboardPage() {

    const [loading, setLoading] = useState<boolean>(true);
    const [tollAreaStats, setTollAreaStats] = useState<TollAreaStatistics[]>([]);
    const [totalData, setTotalData] = useState<TollAreaStatistics>();
    const [filterMap, setFilterMap] = useState<Map<string, FilterSearchPayload>>(new Map(
        Object.entries({...GlobalUtils.getPreviousMonthFilter()})
    ))
    const [filterTemplates] = useState<FilterInputTemplate[]>([
        {
            label: "Tháng",
            placeholder: "Chọn tháng",
            type: FilterInputType.month,
        },
    ])


    const getTollAreaStats = async () => {
        setLoading(true);
        const previousMonth = GlobalUtils.getPreviousMonthFilter()
        const year = filterMap.get("year")?.value??previousMonth.year.value
        const month = filterMap.get("month")?.value??previousMonth.month.value;
        const _tollAreaStats = await tollAreaRepo.getStatistics({month: month.toString(), year: year.toString()});
        if (_tollAreaStats) {
            setTollAreaStats(_tollAreaStats);
        }
        setLoading(false);
    }

    useEffect(()=>{
        if (tollAreaStats.length > 0) {
            const _totalData = tollAreaStats.reduce((acc, item) => ({
                districtName: "",
                wardName: "",
                tollAreaName: "",
                districtId: "",
                wardId: "",
                tollAreaId: "",
                tongSoKhachHang: acc.tongSoKhachHang + item.tongSoKhachHang,
                soLuongCaiApp: acc.soLuongCaiApp + item.soLuongCaiApp,
                tongTienPhaiDong: acc.tongTienPhaiDong + item.tongTienPhaiDong,
                tongTienDaDong: acc.tongTienDaDong + item.tongTienDaDong,
                soLuongHoaDon: acc.soLuongHoaDon + item.soLuongHoaDon,
                tongLuongNuoc: acc.tongLuongNuoc + item.tongLuongNuoc,
                tongTienTruocThue: acc.tongTienTruocThue + item.tongTienTruocThue,
                tongThue: acc.tongThue + item.tongThue,
                tongThueBVMT: acc.tongThueBVMT + item.tongThueBVMT,
                tongDoanhThu: acc.tongDoanhThu + item.tongDoanhThu,
                tongTienGiamGia: acc.tongTienGiamGia + item.tongTienGiamGia,
                tongPhaiThu: acc.tongPhaiThu + item.tongPhaiThu,
                daThu: acc.daThu + item.daThu,
                chuaThu: acc.chuaThu + item.chuaThu,
                soHoaDonDaThu: acc.soHoaDonDaThu + item.soHoaDonDaThu,
                soHoaDonChuaThu: acc.soHoaDonChuaThu + item.soHoaDonChuaThu,
            }))
            setTotalData(_totalData);
        }
    }, [tollAreaStats])

    useEffect(()=>{
        getTollAreaStats();
    },  [filterMap])
    
    async function onFilterChange(map: Map<string, FilterSearchPayload>) {
        setFilterMap(new Map(map));
    }

    return (
    <div className="p-4">
        <FilterBar setMap={setFilterMap} onChange={onFilterChange} templates={filterTemplates} map={filterMap} hideResetButton noCache/>
        <div className='mb-4'></div>
        {loading
            ?<div className='w-full flex flex-col justify-start items-center h-[80vh]'>
                <div className='mt-20'><Spin></Spin></div>
            </div>
            :<TollAreaStatisticsTable data={tollAreaStats} totalData={totalData} 
                month={filterMap.get("month")?.value??GlobalUtils.getPreviousMonthFilter().month.value} 
                year={filterMap.get("year")?.value??GlobalUtils.getPreviousMonthFilter().year.value}/>
        }
        <HelpModal />
    </div>)
}